import { styled } from '@mui/material';
import { ReactComponent as IconOracle } from '../../../assets/images/oracle.svg';

export const StyledIconOracle = styled(IconOracle)(() => ({
  height: '46px',
  width: '46px',
}));
